import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { HttpService } from 'services/http.service';
import { ServiceBase } from 'services/servicebase';
import { environment } from '../../../environments/environment';
import { TypeExitInverviewModel } from 'services/models/offboarding/typeExitInterview.model';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { BYPASS_LOG } from '@core/interceptors/loading-screen.interceptor';
import { OptionModel } from 'services/models/model';
import { QueryParams } from 'services/models/odata/queryParams';
import { ExitInterviewItemModel } from 'services/models/offboarding/exitInterviewItem.model';
import { Filter } from 'services/models/odata/filter';
import { ExitInterviewItemType } from 'services/models/offboarding/enum/exitInterview-item-type.enum';

@Injectable()
export class ExitInterviewFormService extends ServiceBase<TypeExitInverviewModel> {
  constructor(
    http: HttpService,
    private httpClient: HttpClient
  ) {
    super('exitInterview/form', http, environment.apiUrl);
  }

  createEntity(input: any): TypeExitInverviewModel {
    return TypeExitInverviewModel.create(input);
  }

  public listForms(formId?: string): Observable<TypeExitInverviewModel[]> {
    return this.http.get(`${this.endpoint}/list`, null, null, null, true).pipe(
      map(response => {
        const body = response.body;
        if (Array.isArray(body)) {
          return body.map(item => TypeExitInverviewModel.create(item));
        }
        return [];
      })
    );
  }

  public getStructure(formId: string): Observable<TypeExitInverviewModel> {
    return this.http
      .get(`${this.endpoint}/structure/${formId}`, null, null, null, true)
      .pipe(map(response => TypeExitInverviewModel.create(response.body)));
  }

  public clone(formId: string): Observable<TypeExitInverviewModel> {
    return this.http
      .get(`${this.endpoint}/structure/${formId}/clone`, null, null, null, true)
      .pipe(map(response => TypeExitInverviewModel.create(response.body)));
  }

  public updateForm(form: any): Observable<any> {
    return this.http.put(`${this.endpoint}/update`, form);
  }

  public createForm(form: any): Observable<any> {
    return this.http.post(`${this.endpoint}/create`, form, null, null, true);
  }

  public removeFormElement(
    queryParams: { groupId: string; itemId: string; optionId: string },
    disableLoanding = true
  ): Observable<any> {
    const opt = {
      context: new HttpContext().set(BYPASS_LOG, disableLoanding),
      params: new HttpParams({ fromObject: queryParams }),
    };

    return this.httpClient
      .delete<any>(`${this.baseUrl}/${this.endpoint}/remove-form-element`, opt)
      .pipe(map(response => response));
  }

  public changeStatusForm(idObject: string): Observable<any> {
    return this.http.put(`${this.endpoint}/change-status/${idObject}`, {});
  }
}
